import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import supabase from '../Services/Supabase';

const PrivateRoute = ({ element }) => {
  const [authenticated, setAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const { data: { session } } = await supabase.auth.getSession();
        setAuthenticated(!!session);
      } catch (error) {
        console.error('Errore di autenticazione:', error);
        setAuthenticated(false);
      } finally {
        setLoading(false);
      }
    };

    checkAuth();

    const { data: authListener } = supabase.auth.onAuthStateChange((event, session) => {
      setAuthenticated(!!session);
      setLoading(false);
    });

    return () => {
      if (authListener?.subscription) {
        authListener.subscription.unsubscribe();
      }
    };
  }, []);

  if (loading) {
    return <div>Caricamento...</div>;
  }

  // Reindirizza a /login se non autenticato
  if (!authenticated) {
    return <Navigate to="/login" replace state={{ from: window.location.pathname }} />;
  }

  return element;
};

export default PrivateRoute;